/* T FOR ALL — product card: rotate photos with arrows + color-swatch photo switch. */
(function () {
  function initCard(card) {
    if (card.dataset.cardInit) return;
    card.dataset.cardInit = '1';
    var slides = Array.prototype.slice.call(card.querySelectorAll('.tfa-card__slide'));
    if (!slides.length) return;
    var idx = 0;
    function show(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
    }
    var prev = card.querySelector('[data-card-prev]');
    var next = card.querySelector('[data-card-next]');
    if (prev) prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx - 1); });
    if (next) next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); show(idx + 1); });

    card.querySelectorAll('[data-swatch-img]').forEach(function (sw) {
      sw.addEventListener('click', function (e) {
        e.preventDefault();
        var url = sw.getAttribute('data-swatch-img');
        var img = slides[0] && slides[0].querySelector('img');
        if (url && img) { img.removeAttribute('srcset'); img.src = url; }
        show(0);
        card.querySelectorAll('.tfa-card__swatch').forEach(function (s) { s.classList.remove('is-active'); });
        sw.classList.add('is-active');
      });
    });
  }
  function init(root) { (root || document).querySelectorAll('[data-product-card]').forEach(initCard); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
